// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__XPqat","upload":"Small_upload__1XMpI","imageWrap":"Small_imageWrap__2ePma","removeBtn":"Small_removeBtn__3zaGG"};